import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'ad-excel-viewer',
  templateUrl: './ad-excel-viewer.component.html',
  styleUrls: ['./ad-excel-viewer.component.scss']
})
export class AdExcelViewerComponent implements OnInit {

  src: SafeUrl;
  _documentId;
  @Input() set documentId(val) {
    this._documentId = val;
    this.src = this.sanitizer.bypassSecurityTrustResourceUrl(`assets/cells/Viewer/index.html?id=${this.documentId}`)
  }

  get documentId() {
    return this._documentId;
  }
  @Input() open = true;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit(): void {

  }

}
